import React from 'react';
import { Table } from 'reactstrap';
import { formatTRY } from '../../utils/currency';

const InstallmentTable = ({
                              options,               // [{ installmentCount, commissionPercent, enabled, cardBrand }, ...] filtrelenmiş
                              selectedCount,
                              onSelect,              // (count, commissionPercent) => void
                              amount                 // TL base amount (number)
                          }) => {
    if (!options || !options.length) {
        return <div className="alert alert-warning">Bu kart için taksit seçeneği yok.</div>;
    }

    return (
        <div>
            <label className="fw-bold mb-2">TAKSİT SEÇİMİ</label>
            <Table bordered>
                <thead>
                <tr>
                    <th></th>
                    <th>Aylık</th>
                    <th>Toplam</th>
                </tr>
                </thead>
                <tbody>
                {options.map(r => {
                    const divisor = (100 - r.commissionPercent) / 100;
                    const total = amount / divisor;
                    const monthly = r.installmentCount > 1 ? total / r.installmentCount : null;
                    return (
                        <tr key={r.installmentCount}>
                            <td>
                                <input
                                    type="radio"
                                    name="installment_radio"
                                    value={r.installmentCount}
                                    checked={selectedCount === r.installmentCount}
                                    onChange={() => onSelect(r.installmentCount, r.commissionPercent)}
                                />{' '}
                                {r.installmentCount === 1 ? 'Tek Çekim' : `${r.installmentCount} Taksit`}
                            </td>
                            <td>{monthly ? formatTRY(monthly) : '-'}</td>
                            <td>{formatTRY(total)}</td>
                        </tr>
                    );
                })}
                </tbody>
            </Table>
        </div>
    );
};

export default InstallmentTable;